import { BetweenDates } from "../Betweendates";

export default function AdvanceSearchBetweenDates({
  searchObject,
  setSearchObject,
  t
}) {
  return (
    <>
      <div>
        <legend className="fontsize-legend">{t("Between Dates")}</legend>
        <BetweenDates
          setObeject={setSearchObject}
          dateObject={searchObject}
          dateEndField="endingDate"
          dateStartField="startingDate"
        />
      </div>
    </>
  );
}
